import {
  CheckIcon,
  CheckOutlinedIcon,
  ErrorIcon,
  ErrorOutlinedIcon,
  InfoIcon,
  WarningIcon,
} from 'assets/icons';

import { StatusEnum } from 'constants/status';
import { COLOR_PALETTE } from 'constants/ui';

export const StatusIconComponents = {
  [StatusEnum.SUCCESS]: CheckIcon,
  [StatusEnum.ERROR]: ErrorIcon,
  [StatusEnum.WARNING]: WarningIcon,
  [StatusEnum.INFO]: InfoIcon,
};

export const StatusIconComponentsOutlines = {
  [StatusEnum.SUCCESS]: CheckOutlinedIcon,
  [StatusEnum.ERROR]: ErrorOutlinedIcon,
};

export const statusIconColorPairs = {
  [StatusEnum.ERROR]: {
    backgroundColor: COLOR_PALETTE.RED[2],
    color: COLOR_PALETTE.RED[7],
  },
  [StatusEnum.WARNING]: {
    backgroundColor: COLOR_PALETTE.ORANGE[2],
    color: COLOR_PALETTE.ORANGE[7],
  },
  [StatusEnum.SUCCESS]: {
    backgroundColor: COLOR_PALETTE.GREEN[2],
    color: COLOR_PALETTE.GREEN[7],
  },
};
